import { Component, Inject, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
// import { ConsoleReporter } from "jasmine";
import { SopConfigListModel } from "src/app/model/SopConfigListModel";
import { SopConfigResponse } from "src/app/model/SopConfigResponse";
import { SopFormResponse } from "src/app/model/SopFormResponse";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "app-secure-sop-management-au",
  templateUrl: "./sop-management-au.component.html",
  styleUrls: ["./sop-management-au.component.scss"],
})
export class SopManagementAuComponent implements OnInit {
  lotteryKey: number;
  pageMode: string;
  lotteryResponseModel: SopFormResponse;

  lotteryEventId: number;
  sopConfigResponse: SopConfigResponse[] = [];
  isDataLoading: boolean = true;
  sopConfigLst: SopConfigListModel[];

  dataSource: MatTableDataSource<SopConfigResponse[]> =
    new MatTableDataSource();

  form: FormGroup = new FormGroup({});

  isSubmitDisabled: boolean = false;
  lotteryList: { [key: number]: string };
  sopList: { [key: number]: string };
  sopConfigurationTypeList: string[];
  isLoading = false;
  sopConfigurationForm: any;
  // fileMap: { [key: number]: string | ArrayBuffer } = {};
  fileMap: { [key: number]: { data: string | ArrayBuffer; name: string } } = {};

  constructor(
    private router: Router,
    private masterService: MasterService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService.getAllLotteryListForSop().subscribe((data) => {
      this.lotteryResponseModel = data;
      this.lotteryList = this.lotteryResponseModel.lottery;
      this.sopList = this.lotteryResponseModel.sopMaster;
      this.isLoading = false;
    });

    this.form = new FormGroup({
      lotteryKey: new FormControl(null, Validators.required),
      sopKey: new FormControl(null, Validators.required),
      sopType: new FormControl(null, Validators.required),
      sopConfigSubSteps: new FormArray([]),
    });
  }

  onSubmit() {
    // console.log(this.form);
    // if (this.form.valid) {
    this.save();
    // } else {
    //   // this.isSubmitDisabled = false;
    //   this.errorToast("Please complete all Steps.");
    // }
  }

  save() {
    let isComplete = this.form.value.sopConfigSubSteps.filter(
      (r) => r.isComplete == false
    );
    if (isComplete.length > 0) {
      return this.errorToast("Please complete all Steps.");
    }

    this.masterService
      .saveSop({
        lotteryId: this.form.value.lotteryKey?.key,
        sopMasterKey: this.form.value.sopKey?.key,
        sopListModel: this.form.value.sopConfigSubSteps.map((so) => ({
          key: so.key,
          comment: so.comment,
          isComplete: so.isComplete,
          file: this.fileMap[so.key]?.data,
        })),
      })
      .subscribe((data: any) => {
        if (data.status === "SUCCESS") {
          this.successToast();
          this.router.navigate(["/secure", "sop-management", "list"]);
        }
      });
  }
  get sopConfigFromArray() {
    return this.form.get("sopConfigSubSteps")["controls"];
  }

  generateSOPTemplate() {
    console.log(this.form.value.sopKey?.key);
    if (this.form.value?.lotteryKey?.key) {
      if (this.form.value.sopKey?.key) {
        this.masterService
          .downloadSopTemplate(this.form.value.sopKey?.key)
          .subscribe(
            (data) => {
              this.isLoading = false;
              if (data.status === "SUCCESS") {
                console.log(data);
                this.downloadFile(data.base64File, data.fileName);
              } else {
                this.errorToast(data.errorMessage);
              }
            },
            (error) => {
              this.isLoading = false;
              this.errorToast(
                error?.error?.message ||
                  error?.errorMessage ||
                  error?.error?.errorMessage
              );
            }
          );
      } else {
        this.masterService.errorToast("Please Select SOP Type");
      }
    } else {
      this.masterService.errorToast("Please Select Lottery");
    }
  }

  onLotteryChange(value: any) {
    this.lotteryEventId = value?.key;
  }

  onChangeSOPType(value: any) {
    console.log(value?.key);
    this.isDataLoading = false;
    this.clearData();
    if (this.lotteryEventId != null) {
      this.masterService
        .fetchSopConfig(value?.key, this.lotteryEventId)
        .subscribe((data) => {
          console.log(data);
          if (data.status === "SUCCESS") {
            this.isDataLoading = true;
            this.sopConfigResponse = data.sopConfigurationResponses;
            console.log("sopConfigResponse = " + this.sopConfigResponse);

            let sopConfigSubStepsLst: FormArray = this.form.get(
              "sopConfigSubSteps"
            ) as FormArray;

            for (let k = 0; k < this.sopConfigResponse.length; k++) {
              let sopConfigResponseObj = this.sopConfigResponse[k];

              let frmGrp = new FormGroup({
                key: new FormControl(sopConfigResponseObj.sopConfigurationKey),
                displaySequence: new FormControl(
                  sopConfigResponseObj.displaySequence
                ),
                sopConfigurationResponses: new FormArray([]),
                steps: new FormControl(sopConfigResponseObj.steps),
                comment: new FormControl(null),
                file: new FormControl(null),
                isComplete: new FormControl(false),
              });

              sopConfigSubStepsLst.push(frmGrp);
            }
          } else {
            this.isDataLoading = true;
            this.errorToast(data.errorMessage);
          }
        });
    } else {
      this.isDataLoading = true;
      this.errorToast("Please Select lottery");
    }
  }

  clearData() {
    // return this.form.get("sopConfigSubSteps")["controls"].clear;
    const sopConfigSubStepsArray = this.form.get(
      "sopConfigSubSteps"
    ) as FormArray;
    sopConfigSubStepsArray.clear(); // Clear the array
    return sopConfigSubStepsArray.controls;
  }
  onFileSelect(event, key: number) {
    let selectedFile = event.target.files[0];
    // console.log("dd " + key);

    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = () => {
      this.fileMap[key] = { data: reader.result, name: selectedFile.name };
      // this.fileMap[key] = reader.result;
    };
  }

  getFileName(key: number): string {
    return this.fileMap[key] ? this.fileMap[key].name : "";
  }

  onCheckboxChange(e: any) {
    if (e.target) {
      this.isSubmitDisabled = false;
      console.log("check box ticked");
    }
  }
  async successToast() {
    await this._snackBar.open(
      "SOP Management details saved successfully.",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async warningToast() {
    await this._snackBar.open("", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }
}
